import { Page } from "@/models/page-models/Page";

export const AllOpenCustomers: Page = {
  "path": "AllOpenCustomers",
  "name": "AllOpenCustomers",
  "props": {
    "data": {
      "title": "AllOpenCustomers",
      "printable": "FALSE",
      "url": "AllOpenCustomers",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "label": "All Open Customers",
                  "disabled": "FALSE",
                  "items": "fetchedData.openCustomers.data",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "ID#",
                      "type": "url",
                      "url": "/customers/{{__item._id}}"
                    },
                    {
                      "value": "__item.name",
                      "text": "Customer Name"
                    },
                    {
                      "value": "nameArabic",
                      "text": "Name Arabic"
                    },
                    {
                      "value": "alias",
                      "text": "Alias"
                    },
                    {
                      "value": "assignedTo.displayName",
                      "text": "Assigned To"
                    },
                    {
                      "value": "CRNumber",
                      "text": "CR#"
                    },
                    {
                      "value": "VATNumber",
                      "text": "VAT#"
                    },
                    {
                      "value": "status",
                      "text": "Type"
                    },
                    {
                      "value": "customerType",
                      "text": "Customer Type"
                    },
                    {
                      "value": "customerCategory",
                      "text": "Customer Category"
                    },
                    {
                      "value": "customerTypeByActivity",
                      "text": "Customer Type By Activity"
                    },
                    {
                      "value": "customerTypeBySize",
                      "text": "Customer Type By Size"
                    },
                    {
                      "value": "groups",
                      "text": "Groups",
                      "formula": "fn(HELPER_FN,joinArray,{{__item.groups}},name)"
                    },
                    {
                      "value": "region",
                      "text": "Region"
                    },
                    {
                      "value": "exportCustomer",
                      "text": "Export Customer"
                    },
                    {
                      "value": "currency",
                      "text": "Currency"
                    },
                    {
                      "value": "termsAndConditions.tradeTerms.type",
                      "text": "Trade Terms"
                    },
                    {
                      "value": "termsAndConditions.paymentTerms.type",
                      "text": "Payment Terms"
                    },
                    {
                      "value": "termsAndConditions.paymentTerms.advancePercent",
                      "text": "Advance Percent"
                    },
                    {
                      "value": "termsAndConditions.creditTerms.ceiling",
                      "text": "Credit Ceiling",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.termsAndConditions.creditTerms.ceiling}},true)"
                    },
                    {
                      "value": "active",
                      "text": "Status",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,agingStatus,{{__item}})"
                    },
                    {
                      "value": "isDeleted",
                      "text": "Is Deleted"
                    },
                    {
                      "value": "reason",
                      "text": "Reason"
                    },
                    {
                      "value": "__item.createdAt",
                      "text": "Created At",
                      "type": "date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                    },
                    {
                      "value": "__item.updatedAt",
                      "text": "Updated At",
                      "type": "date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                    },
                    {
                      "value": "__item.prospectApprovedAt",
                      "text": "Prospect Approved At",
                      "type": "date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.prospectApprovedAt}})"
                    },
                    {
                      "value": "__item.customerApprovedAt",
                      "text": "Customer Approved At",
                      "type": "date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.customerApprovedAt}})"
                    },
                    {
                      "value": "__item.skipDisableUntil",
                      "text": "Override Date",
                      "type": "date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.skipDisableUntil}})"
                    },
                    {
                      "value": "__item.createdBy.displayName",
                      "text": "Created By"
                    },
                    {
                      "value": "__item.createdBy._id",
                      "text": "Created By ID"
                    },
                    {
                      "value": "billingContact",
                      "text": "Billing Contact"
                    },
                    {
                      "value": "address.alias_en",
                      "text": "Billing Address(EN)"
                    },
                    {
                      "value": "address.alias_ar",
                      "text": "Billing Address(AR)"
                    },
                    {
                      "value": "address.geometry.location.lat",
                      "text": "Billing Address Latitude"
                    },
                    {
                      "value": "address.geometry.location.lng",
                      "text": "Billing Address Longitude"
                    },
                    {
                      "value": "supplierCode",
                      "text": "Cadis Supplier Code"
                    },
                    {
                      "value": "nationalAddress.addressCode",
                      "text": "Nat. Address Short Code"
                    },
                    {
                      "value": "nationalAddress.en.streetName",
                      "text": "Nat. Address Street (EN)"
                    },
                    {
                      "value": "nationalAddress.en.buildNumber",
                      "text": "Nat. Address Building# (EN)"
                    },
                    {
                      "value": "nationalAddress.en.additionalNumber",
                      "text": "Nat. Address Additional# (EN)"
                    },
                    {
                      "value": "nationalAddress.en.cityName",
                      "text": "Nat. Address City (EN)"
                    },
                    {
                      "value": "nationalAddress.en.postalCode",
                      "text": "Nat. Address Postal Code (EN)"
                    },
                    {
                      "value": "nationalAddress.en.district",
                      "text": "Nat. Address District (EN)"
                    },
                    {
                      "value": "nationalAddress.en.country",
                      "text": "Nat. Address Country (EN)"
                    },
                    {
                      "value": "nationalAddress.en.countryCode",
                      "text": "Nat. Address Country Code (EN)"
                    },
                    {
                      "value": "nationalAddress.ar.streetName",
                      "text": "Nat. Address Street (AR)"
                    },
                    {
                      "value": "nationalAddress.ar.buildNumber",
                      "text": "Nat. Address Building# (AR)"
                    },
                    {
                      "value": "nationalAddress.ar.additionalNumber",
                      "text": "Nat. Address Additional# (AR)"
                    },
                    {
                      "value": "nationalAddress.ar.cityName",
                      "text": "Nat. Address City (AR)"
                    },
                    {
                      "value": "nationalAddress.ar.postalCode",
                      "text": "Nat. Address Postal Code (AR)"
                    },
                    {
                      "value": "nationalAddress.ar.district",
                      "text": "Nat. Address District (AR)"
                    },
                    {
                      "value": "nationalAddress.ar.country",
                      "text": "Nat. Address Country (AR)"
                    },
                    {
                      "value": "nationalAddress.ar.countryCode",
                      "text": "Nat. Address Country Code (AR)"
                    },                
                    {
                      "value": "schemeId",
                      "text": "Miscellaneous Customer ID Type (Scheme ID)"
                    },
                    {
                      "value": "identification",
                      "text": "Miscellaneous Customer ID #"
                    },
                                        {
                      "value": "socialMedia[0].link",
                      "text": "Social Media Link 1"
                    },
                    {
                      "value": "socialMedia[1].link",
                      "text": "Social Media Link 2"
                    },
                    {
                      "value": "socialMedia[2].link",
                      "text": "Social Media Link 3"
                    },
                    {
                      "value": "contactDetails[0].prefix",
                      "text": "Contact 1 Prefix"
                    },
                    {
                      "value": "contactDetails[0].firstName",
                      "text": "Contact 1 First Name"
                    },
                    {
                      "value": "contactDetails[0].lastName",
                      "text": "Contact 1 Last Name"
                    },
                    {
                      "value": "contactDetails[0].mobile",
                      "text": "Contact 1 Mobile"
                    },
                    {
                      "value": "contactDetails[0].position",
                      "text": "Contact 1 Position"
                    },
                    {
                      "value": "contactDetails[0].email",
                      "text": "Contact 1 Email"
                    },
                    {
                      "value": "contactDetails[1].prefix",
                      "text": "Contact 2 Prefix"
                    },
                    {
                      "value": "contactDetails[1].firstName",
                      "text": "Contact 2 First Name"
                    },
                    {
                      "value": "contactDetails[1].lastName",
                      "text": "Contact 2 Last Name"
                    },
                    {
                      "value": "contactDetails[1].mobile",
                      "text": "Contact 2 Mobile"
                    },
                    {
                      "value": "contactDetails[1].position",
                      "text": "Contact 2 Position"
                    },
                    {
                      "value": "contactDetails[1].email",
                      "text": "Contact 2 Email"
                    },
                    {
                      "value": "contactDetails[2].prefix",
                      "text": "Contact 3 Prefix"
                    },
                    {
                      "value": "contactDetails[2].firstName",
                      "text": "Contact 3 First Name"
                    },
                    {
                      "value": "contactDetails[2].lastName",
                      "text": "Contact 3 Last Name"
                    },
                    {
                      "value": "contactDetails[2].mobile",
                      "text": "Contact 3 Mobile"
                    },
                    {
                      "value": "contactDetails[2].position",
                      "text": "Contact 3 Position"
                    },
                    {
                      "value": "contactDetails[2].email",
                      "text": "Contact 3 Email"
                    },
                    {
                      "value": "contactDetails[3].prefix",
                      "text": "Contact 4 Prefix"
                    },
                    {
                      "value": "contactDetails[3].firstName",
                      "text": "Contact 4 First Name"
                    },
                    {
                      "value": "contactDetails[3].lastName",
                      "text": "Contact 4 Last Name"
                    },
                    {
                      "value": "contactDetails[3].mobile",
                      "text": "Contact 4 Mobile"
                    },
                    {
                      "value": "contactDetails[3].position",
                      "text": "Contact 4 Position"
                    },
                    {
                      "value": "contactDetails[3].email",
                      "text": "Contact 4 Email"
                    },
                    {
                      "value": "contactDetails[4].prefix",
                      "text": "Contact 5 Prefix"
                    },
                    {
                      "value": "contactDetails[4].firstName",
                      "text": "Contact 5 First Name"
                    },
                    {
                      "value": "contactDetails[4].lastName",
                      "text": "Contact 5 Last Name"
                    },
                    {
                      "value": "contactDetails[4].mobile",
                      "text": "Contact 5 Mobile"
                    },
                    {
                      "value": "contactDetails[4].position",
                      "text": "Contact 5 Position"
                    },
                    {
                      "value": "contactDetails[4].email",
                      "text": "Contact 5 Email"
                    },
                    {
                      "value": "contactDetails[5].prefix",
                      "text": "Contact 6 Prefix"
                    },
                    {
                      "value": "contactDetails[5].firstName",
                      "text": "Contact 6 First Name"
                    },
                    {
                      "value": "contactDetails[5].lastName",
                      "text": "Contact 6 Last Name"
                    },
                    {
                      "value": "contactDetails[5].mobile",
                      "text": "Contact 6 Mobile"
                    },
                    {
                      "value": "contactDetails[5].position",
                      "text": "Contact 6 Position"
                    },
                    {
                      "value": "contactDetails[5].email",
                      "text": "Contact 6 Email"
                    },
                    {
                      "value": "contactDetails[6].prefix",
                      "text": "Contact 7 Prefix"
                    },
                    {
                      "value": "contactDetails[6].firstName",
                      "text": "Contact 7 First Name"
                    },
                    {
                      "value": "contactDetails[6].lastName",
                      "text": "Contact 7 Last Name"
                    },
                    {
                      "value": "contactDetails[6].mobile",
                      "text": "Contact 7 Mobile"
                    },
                    {
                      "value": "contactDetails[6].position",
                      "text": "Contact 7 Position"
                    },
                    {
                      "value": "contactDetails[6].email",
                      "text": "Contact 7 Email"
                    },
                    {
                      "value": "contactDetails[7].prefix",
                      "text": "Contact 8 Prefix"
                    },
                    {
                      "value": "contactDetails[7].firstName",
                      "text": "Contact 8 First Name"
                    },
                    {
                      "value": "contactDetails[7].lastName",
                      "text": "Contact 8 Last Name"
                    },
                    {
                      "value": "contactDetails[7].mobile",
                      "text": "Contact 8 Mobile"
                    },
                    {
                      "value": "contactDetails[7].position",
                      "text": "Contact 8 Position"
                    },
                    {
                      "value": "contactDetails[7].email",
                      "text": "Contact 8 Email"
                    },
                    {
                      "value": "contactDetails[8].prefix",
                      "text": "Contact 9 Prefix"
                    },
                    {
                      "value": "contactDetails[8].firstName",
                      "text": "Contact 9 First Name"
                    },
                    {
                      "value": "contactDetails[8].lastName",
                      "text": "Contact 9 Last Name"
                    },
                    {
                      "value": "contactDetails[8].mobile",
                      "text": "Contact 9 Mobile"
                    },
                    {
                      "value": "contactDetails[8].position",
                      "text": "Contact 9 Position"
                    },
                    {
                      "value": "contactDetails[8].email",
                      "text": "Contact 9 Email"
                    },
                    {
                      "value": "contactDetails[9].prefix",
                      "text": "Contact 10 Prefix"
                    },
                    {
                      "value": "contactDetails[9].firstName",
                      "text": "Contact 10 First Name"
                    },
                    {
                      "value": "contactDetails[9].lastName",
                      "text": "Contact 10 Last Name"
                    },
                    {
                      "value": "contactDetails[9].mobile",
                      "text": "Contact 10 Mobile"
                    },
                    {
                      "value": "contactDetails[9].position",
                      "text": "Contact 10 Position"
                    },
                    {
                      "value": "contactDetails[9].email",
                      "text": "Contact 10 Email"
                    },
                    {
                      "value": "deliveryAddresses[0].ref",
                      "text": "Delivery Address 1 Alias"
                    },
                    {
                      "value": "deliveryAddresses[0].location.alias_en",
                      "text": "Delivery Address 1(EN)"
                    },
                    {
                      "value": "deliveryAddresses[0].location.alias_ar",
                      "text": "Delivery Address 1(AR)"
                    },
                    {
                      "value": "deliveryAddresses[0].location.geometry.location.lat",
                      "text": "Delivery Address 1 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[0].location.geometry.location.lng",
                      "text": "Delivery Address 1 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[0].assignedContact",
                      "text": "Delivery Address 1 Assigned Contact"
                    },
                    {
                      "value": "deliveryAddresses[1].ref",
                      "text": "Delivery Address 2 Alias"
                    },
                    {
                      "value": "deliveryAddresses[1].location.alias_en",
                      "text": "Delivery Address 2(EN)"
                    },
                    {
                      "value": "deliveryAddresses[1].location.alias_ar",
                      "text": "Delivery Address 2(AR)"
                    },
                    {
                      "value": "deliveryAddresses[1].location.geometry.location.lat",
                      "text": "Delivery Address 2 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[1].location.geometry.location.lng",
                      "text": "Delivery Address 2 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[1].assignedContact",
                      "text": "Delivery Address 2 Assigned Contact"
                    },
                    {
                      "value": "deliveryAddresses[2].ref",
                      "text": "Delivery Address 3 Alias"
                    },
                    {
                      "value": "deliveryAddresses[2].location.alias_en",
                      "text": "Delivery Address 3(EN)"
                    },
                    {
                      "value": "deliveryAddresses[2].location.alias_ar",
                      "text": "Delivery Address 3(AR)"
                    },
                    {
                      "value": "deliveryAddresses[2].location.geometry.location.lat",
                      "text": "Delivery Address 3 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[2].location.geometry.location.lng",
                      "text": "Delivery Address 3 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[2].assignedContact",
                      "text": "Delivery Address 3 Assigned Contact"
                    },
                    {
                      "value": "deliveryAddresses[3].ref",
                      "text": "Delivery Address 4 Alias"
                    },
                    {
                      "value": "deliveryAddresses[3].location.alias_en",
                      "text": "Delivery Address 4(EN)"
                    },
                    {
                      "value": "deliveryAddresses[3].location.alias_ar",
                      "text": "Delivery Address 4(AR)"
                    },
                    {
                      "value": "deliveryAddresses[3].location.geometry.location.lat",
                      "text": "Delivery Address 4 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[3].location.geometry.location.lng",
                      "text": "Delivery Address 4 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[3].assignedContact",
                      "text": "Delivery Address 4 Assigned Contact"
                    },
                    {
                      "value": "deliveryAddresses[4].ref",
                      "text": "Delivery Address 5 Alias"
                    },
                    {
                      "value": "deliveryAddresses[4].location.alias_en",
                      "text": "Delivery Address 5(EN)"
                    },
                    {
                      "value": "deliveryAddresses[4].location.alias_ar",
                      "text": "Delivery Address 5(AR)"
                    },
                    {
                      "value": "deliveryAddresses[4].location.geometry.location.lat",
                      "text": "Delivery Address 5 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[4].location.geometry.location.lng",
                      "text": "Delivery Address 5 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[4].assignedContact",
                      "text": "Delivery Address 5 Assigned Contact"
                    },
                    {
                      "value": "deliveryAddresses[5].ref",
                      "text": "Delivery Address 6 Alias"
                    },
                    {
                      "value": "deliveryAddresses[5].location.alias_en",
                      "text": "Delivery Address 6(EN)"
                    },
                    {
                      "value": "deliveryAddresses[5].location.alias_ar",
                      "text": "Delivery Address 6(AR)"
                    },
                    {
                      "value": "deliveryAddresses[5].location.geometry.location.lat",
                      "text": "Delivery Address 6 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[5].location.geometry.location.lng",
                      "text": "Delivery Address 6 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[5].assignedContact",
                      "text": "Delivery Address 6 Assigned Contact"
                    },
                    {
                      "value": "deliveryAddresses[6].ref",
                      "text": "Delivery Address 7 Alias"
                    },
                    {
                      "value": "deliveryAddresses[6].location.alias_en",
                      "text": "Delivery Address 7(EN)"
                    },
                    {
                      "value": "deliveryAddresses[6].location.alias_ar",
                      "text": "Delivery Address 7(AR)"
                    },
                    {
                      "value": "deliveryAddresses[6].location.geometry.location.lat",
                      "text": "Delivery Address 7 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[6].location.geometry.location.lng",
                      "text": "Delivery Address 7 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[6].assignedContact",
                      "text": "Delivery Address 7 Assigned Contact"
                    },
                    {
                      "value": "deliveryAddresses[7].ref",
                      "text": "Delivery Address 8 Alias"
                    },
                    {
                      "value": "deliveryAddresses[7].location.alias_en",
                      "text": "Delivery Address 8(EN)"
                    },
                    {
                      "value": "deliveryAddresses[7].location.alias_ar",
                      "text": "Delivery Address 8(AR)"
                    },
                    {
                      "value": "deliveryAddresses[7].location.geometry.location.lat",
                      "text": "Delivery Address 8 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[7].location.geometry.location.lng",
                      "text": "Delivery Address 8 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[7].assignedContact",
                      "text": "Delivery Address 8 Assigned Contact"
                    },
                    {
                      "value": "deliveryAddresses[8].ref",
                      "text": "Delivery Address 9 Alias"
                    },
                    {
                      "value": "deliveryAddresses[8].location.alias_en",
                      "text": "Delivery Address 9(EN)"
                    },
                    {
                      "value": "deliveryAddresses[8].location.alias_ar",
                      "text": "Delivery Address 9(AR)"
                    },
                    {
                      "value": "deliveryAddresses[8].location.geometry.location.lat",
                      "text": "Delivery Address 9 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[8].location.geometry.location.lng",
                      "text": "Delivery Address 9 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[8].assignedContact",
                      "text": "Delivery Address 9 Assigned Contact"
                    },
                    {
                      "value": "deliveryAddresses[9].ref",
                      "text": "Delivery Address 10 Alias"
                    },
                    {
                      "value": "deliveryAddresses[9].location.alias_en",
                      "text": "Delivery Address 10(EN)"
                    },
                    {
                      "value": "deliveryAddresses[9].location.alias_ar",
                      "text": "Delivery Address 10(AR)"
                    },
                    {
                      "value": "deliveryAddresses[9].location.geometry.location.lat",
                      "text": "Delivery Address 10 Latitude"
                    },
                    {
                      "value": "deliveryAddresses[9].location.geometry.location.lng",
                      "text": "Delivery Address 10 Longitude"
                    },
                    {
                      "value": "deliveryAddresses[9].assignedContact",
                      "text": "Delivery Address 10 Assigned Contact"
                    },
                    {
                      "value": "__v",
                      "text": "Version"
                    }
                  ],
                  "tableType": "static",
                  "height":"75vh",
                  "fontSize": "0.75rem",
                  "enableGoogleSheetExport": true,
                  "printable": false
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openCustomerForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultOpenCustomerForm"
      },
      {
        "executionOrder": 2,
        "name": "getAllOpenCustomers",
        "executeIf": "fn(MATCH_ROLE,General Manager)"
      }
    ],
    "functions": [
      {
        "name": "getDefaultPageAndLimit",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1",
          "limit": "50",
          "pattern": "{{__selectedObject}}"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultOpenCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "pattern": "",
          "showDisabled": true
        },
        "staticObject": true
      },
      {
        "name": "getAllOpenCustomers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers?showMisc=true",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.openCustomers",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.openCustomerForm"
      }
    ]
  },
  "forRole": "GENERAL_MANAGER",
  "visible": false,
  "routerPriority": 80
}